function DownIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.5 9.5h-6v-9h-9v9h-6L11 20 21.5 9.5zM.5 23v3h21v-3H.5z"
        fill="#4079F5"
      />
    </svg>
  )
}

export default DownIcon
